<div class="flex flex-col gap-4">
    @if (isLoadingData) {
        <div class="flex justify-center p-4">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    }
    @else {
        <div id="chart">
            <apx-chart
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [dataLabels]="chartOptions.dataLabels"
                [markers]="chartOptions.markers"
                [stroke]="chartOptions.stroke"
                [colors]="chartOptions.colors"
                [fill]="chartOptions.fill"
                [legend]="chartOptions.legend"
                [tooltip]="chartOptions.tooltip"
            ></apx-chart>
        </div>
    }
</div>
